import { create } from 'zustand';

import { cropConnectApiClient } from '../services/cropConnectApiClient';
interface PropertyBag {
  parentHeadlineId: string;
  assignmentType: 'ROLES' | 'BP_NUMBERS';
}

export interface GeneralDocument {
  id: number;
  name: string;
  url: string;
  parentWidgetId: string;
  visibleFor: string[];
  PropertyBag: PropertyBag;
}

export interface GeneralDocumentFolder {
  id: number;
  name: string;
  subfolders?: GeneralDocumentFolder[];
  documents?: GeneralDocument[];
}

export interface GeneralDocumentsState {
  generalDocuments: GeneralDocument[];
  addGeneralDocument: (document: GeneralDocument) => void;
  removeGeneralDocument: (document: GeneralDocument) => void;
  updateGeneralDocument: (document: GeneralDocument) => void;
  updateOrCreateGeneralDocument: (document: GeneralDocument) => void;
  getGeneralDocumentsFolder: (
    folderId?: number | undefined
  ) => Promise<GeneralDocumentFolder>;
}

// const addGeneralDocumentWidget = (widget, document) => {
//   const widgetId = cropConnectApiClient.addWidget(widget);
//   cropConnectApiClient.addGeneralDocument(widgetId,..., document)
// }

export const useGeneralDocumentStore = create<GeneralDocumentsState>((set) => ({
  generalDocuments: [] as GeneralDocument[],

  addGeneralDocument: (document: GeneralDocument) =>
    set((state) => ({
      generalDocuments: [...state.generalDocuments, document],
    })),

  removeGeneralDocument: (document: GeneralDocument) =>
    set((state) => {
      const newGeneralDocuments = state.generalDocuments.filter(
        (w) => w.id != document.id
      );
      return { generalDocuments: newGeneralDocuments };
    }),

  updateGeneralDocument: (updatedGeneralDocument: GeneralDocument) =>
    set((state) => ({
      generalDocuments: state.generalDocuments.map((document) =>
        document.id === updatedGeneralDocument.id
          ? updatedGeneralDocument
          : document
      ),
    })),

  updateOrCreateGeneralDocument: (updatedGeneralDocument: GeneralDocument) =>
    set((state) => {
      const existingDocument = state.generalDocuments.find(
        (document) => document.id === updatedGeneralDocument.id
      );
      if (existingDocument) {
        return {
          generalDocuments: state.generalDocuments.map((document) =>
            document.id === updatedGeneralDocument.id
              ? updatedGeneralDocument
              : document
          ),
        };
      } else {
        return {
          generalDocuments: [...state.generalDocuments, updatedGeneralDocument],
        };
      }
    }),
  getGeneralDocumentsFolder: async (folderId?: number | undefined) => {
    const folderResponse =
      await cropConnectApiClient.getGeneralDocumentsFolder(folderId);

    if (folderResponse.success) {
      const folder = {
        id: folderResponse.data!.id,
        name: folderResponse.data!.name,
        documents: folderResponse.data!.documents,
        subfolders: folderResponse.data!.subFolders,
      } as GeneralDocumentFolder;

      return folder;
    } else {
      throw 'Error in getting folder';
    }
  },
}));
